module.exports = __webpack_public_path__ + "img/mc3l-y1.addd2bec.gif";